export default [
    {
      reducerKey: 'referral/list',
      sagaKey: 'referralsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/List/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/saga'),
    },
    {
      reducerKey: 'referral/links',
      sagaKey: 'referralLinksSaga',
      importReducer: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/ReferralLinks/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/ReferralLinks/store/saga'),
    },
    {
      reducerKey: 'referral/clients',
      sagaKey: 'referralClientsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/ReferralClients/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/ReferralClients/store/saga'),
    },
    {
      reducerKey: 'referral/payout-profiles',
      importReducer: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/PayoutProfiles/List/store/reducer'),
    },
    {
      reducerKey: 'referral/payouts-list',
      importReducer: () => import(/* webpackChunkName: "domain-referral" */ 'modules/Referral/PayoutProfiles/Invoices/store/reducer'),
    },
]
